<template>
    <div>
        <template v-if="isBusy">
            <Preloader/>
        </template>

        <template v-else>
            <form method="POST" name="devis_panne_mecanique_standard" @submit.prevent="onSubmit">
                <div class="row">
                    <div class="col-12">
                        <div class="page__head-title page__head-title--orange">
                            <div class="page__head-title__text page__head-title__text--orange">Garantie Auto</div>
                            <div class="page__head-title__notice">(* champs obligatoires)</div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form_ttl">Informations sur le véhicule &agrave; assurer</div>
                    </div>
                    <div class="col-12">
                        <div class="form__item relative">
                            <div class="form__item__label form__item__label--required">Immatriculation</div>
                            <div class="form__item__input-wrapper" :class="{ 'input-addon':existingVehicleFound || isVehicleSearching }">
                                <input type="text" v-model="garantieAuto.immatriculation" name="immatriculation"
                                       id="immatriculation"
                                       @input="searchByRegNumber"
                                       class="input_n"
                                       :class="{input_red_shadow: hasError('immatriculation')}"
                                />

                                <div class="form__item__input-wrapper--loader" v-if="isVehicleSearching">
                                    <Preloader :wrapper-height="'20px'" :size="'20px'" />
                                </div>
                                <!-- <button type="button" @click="fillTheFieldsByImmatriculation" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingVehicleFound && !isVehicleSearching">
                                    Compléter
                                </button> -->
                            </div>
                            <div class="tooltip__wrap">
                               <div class="tooltip__wrap--icon"></div>

                                <div class="tooltip__wrap--text">
                                    <div class="tooltip__wrap--text--notice">Veuillez saisir l'immatriculation du véhicule en lettres majuscules et séparés par un trait d'union. Exemple: AF-785-HT</div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Marque</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.marque_auto" name="marque_auto"
                                       id="marque_auto"
                                       class="input_n"
                                       :disabled="searchVehicleFilled"
                                       :class="{input_red_shadow: hasError('marque_auto')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Mod&egrave;le</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.modele_porteur" name="modele_porteur"
                                       id="modele_porteur"
                                       class="input_n"
                                       :disabled="searchVehicleFilled"
                                       :class="{input_red_shadow: hasError('modele_porteur')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Carburant</div>
                            <div class="form__item__input-wrapper">
                                <select v-model="garantieAuto.carburant" name="carburant" id="carburant" class="select_n"
                                        :disabled="searchVehicleFilled"
                                        :class="{input_red_shadow: hasError('carburant')}"
                                >
                                    <option value="0">Choisir un carburant...</option>
                                    <option value="1">Essence</option>
                                    <option value="2">Diesel</option>
                                    <option value="3">GPL</option>
                                    <option value="4">Electrique</option>
                                    <option value="5">Hybride</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <template v-if="+garantieAuto.carburant === AUTO_ENGINE.ELECTRIC.ID">
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">
                                    Puissance en Kw
                                </div>
                                <div class="form__item__input-wrapper">
                                    <select v-model="garantieAuto.power_kw" name="power_kw" id="puis_kw" class="select_n"
                                            :class="{input_red_shadow: hasError('power_kw')}"
                                    >
                                        <option value="0">Choisir un puissance en Kw</option>
                                        <option value="1">– de 150 Kw</option>
                                        <option value="2">De 150 Kw à 400 Kw</option>
                                        <option value="3">+ de 400 Kw</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Cylindr&eacute;e</div>
                                <div class="form__item__input-wrapper">
                                    <select v-model="garantieAuto.cylindree" name="cylindree" id="cylindree"
                                            :disabled="searchVehicleFilled"
                                            class="select_n" :class="{input_red_shadow: hasError('cylindree')}">
                                        <option value="0">Choisir un type de cylindr&eacute;e</option>
                                        <option value="1">- de 2.5 L</option>
                                        <option value="2">de 2.5 L &agrave; 3.5 L</option>
                                        <option value="3">+ de 3.5 L</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">
                                Puissance fiscale
                            </div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.puis_fisc" name="puis_fisc" id="puis_fisc"
                                       :disabled="searchVehicleFilled"
                                       class="input_n" :class="{input_red_shadow: hasError('puis_fisc')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Date de 1&egrave;re mise en circulation</div>
                            <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                                <CustomDatepicker :date.sync="circulationDateInput" :disabled="searchVehicleFilled" :has-error="hasError('jour_mise_en_circulation')"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Num&eacute;ro de s&eacute;rie</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.num_serie" name="num_serie" id="num_serie"
                                       :disabled="searchVehicleFilled"
                                       class="input_n" :class="{input_red_shadow: hasError('num_serie')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Kilométrage</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.km_reel" name="km_reel" id="km_reel"
                                       class="input_n" :class="{input_red_shadow: hasError('km_reel')}"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Date d'effet</div>
                            <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                                <CustomDatepicker :date.sync="effectiveDateInput" :has-error="hasError('effective_date')"></CustomDatepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form_ttl">Information sur la garantie :</div>
                    </div>

                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">V&eacute;hicule</div>
                            <div class="form__item__input-wrapper">
                                <select v-model="garantieAuto.type_vehicule" name="type_vehicule" id="type_vehicule"
                                        :disabled="searchVehicleFilled"
                                        class="select_n" :class="{input_red_shadow: hasError('type_vehicule')}">
                                    <option value="0">Choisir un type de v&eacute;hicule...</option>
                                    <option v-for="item in vehicleTypeOptions" :value="item.value">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Garantie</div>
                            <div class="form__item__input-wrapper">
                                <select v-model="garantieAuto.garantie" name="garantie" id="garantie" class="select_n"
                                        :class="{input_red_shadow: hasError('garantie')}">
                                    <option value="0" selected="selected">Choisissez une garantie</option>
                                    <option v-for="item in insuranceTypeOptions" :value="item.value">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Dur&eacute;e</div>
                            <div class="form__item__input-wrapper">
                                <select v-model="garantieAuto.duree" name="duree" id="duree" class="select_n"
                                        :class="{input_red_shadow: hasError('duree')}">
                                    <option value="0">Choisir une dur&eacute;e...</option>
                                    <option v-for="item in durationOprions" :value="item.value">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-12">-->
<!--                        <div class="form__item">-->
<!--                            <div class="form__item__label form__item__label&#45;&#45;required">Assistance ?</div>-->
<!--                            <div class="form__item__input-wrapper form__item__input-wrapper&#45;&#45;checkbox">-->
<!--                                <select v-model="garantieAuto.assure" class="select_n w-100">-->
<!--                                    <option value="0">Non</option>-->
<!--                                    <option value="1">Oui</option>-->
<!--                                </select>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="col-12">
                        <div class="form_ttl_first">Informations sur le propri&eacute;taire du v&eacute;hicule</div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Civilit&eacute;</div>
                            <div class="form__item__input-wrapper">
                                <select name="civilite" id="civilite" class="select_civ" v-model="garantieAuto.civilite">
                                    <option value="0">M</option>
                                    <option value="1">Mlle</option>
                                    <option value="2">Mme</option>
                                    <option value="3">Société</option>
                                    <option value="4">Mr et Mme</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <template v-if="garantieAuto.civilite == 3">
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Société</div>
                                <div class="form__item__input-wrapper">
                                    <input type="text" v-model="garantieAuto.name_of_signatory" name="name_of_signatory"
                                           id="name_of_signatory" class="input_n" :class="{input_red_shadow: hasError('name_of_signatory')}"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                          <div class="form__item">
                            <div class="form__item__label form__item__label--required">Nom du signataire</div>
                            <div class="form__item__input-wrapper">
                              <input type="text" v-model="garantieAuto.nom" name="nom" id="nom" class="input_n"
                                     :class="{input_red_shadow: hasError('nom')}"/>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form__item">
                            <div class="form__item__label form__item__label--required">Pr&eacute;nom du signataire</div>
                            <div class="form__item__input-wrapper">
                              <input type="text" v-model="garantieAuto.prenom" name="prenom" id="prenom"
                                     class="input_n" :class="{input_red_shadow: hasError('prenom')}"/>
                            </div>
                          </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="col-12">
                          <div class="form__item">
                            <div class="form__item__label form__item__label--required">Nom</div>
                            <div class="form__item__input-wrapper">
                              <input type="text" v-model="garantieAuto.nom" name="nom" id="nom" class="input_n"
                                     :class="{input_red_shadow: hasError('nom')}"/>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                            <div class="form__item">
                                <div class="form__item__label form__item__label--required">Pr&eacute;nom</div>
                                <div class="form__item__input-wrapper">
                                    <input type="text" v-model="garantieAuto.prenom" name="prenom" id="prenom"
                                           class="input_n" :class="{input_red_shadow: hasError('prenom')}"/>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Adresse</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.adresse" name="adresse" id="adresse"
                                       class="input_n" :class="{input_red_shadow: hasError('addresse')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Code postal</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.cp" name="cp" id="cp" maxlength="5" class="input_n"
                                       :class="{input_red_shadow: hasError('cp')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Ville</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.ville" name="ville" id="ville" class="input_n"
                                       :class="{input_red_shadow: hasError('ville')}"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label">T&eacute;l&eacute;phone</div>
                            <div class="form__item__input-wrapper" :class="{ 'input-addon': existingCustomerFound || isClientSearching }">
                                <input type="text" v-model="garantieAuto.tel" @input="searchClient" name="tel" id="tel" maxlength="10" class="input_n"
                                    :class="{input_red_shadow: hasError('tel')}"
                                />
                                <div class="form__item__input-wrapper--loader" v-if="isClientSearching">
                                  <Preloader :wrapper-height="'20px'" :size="'20px'" />
                                </div>
                                <!-- <button type="button" @click="fillTheFields" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingCustomerFound && !isClientSearching">
                                  Compléter
                                </button> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label">Email</div>
                            <div class="form__item__input-wrapper">
                                <input type="text" v-model="garantieAuto.email" name="email" id="email" class="input_n"
                                       :class="{input_red_shadow: hasError('email')}" />
                            </div>
                        </div>
                    </div>
                    <!--submit-->
                    <div class="col-12">
                        <div class="form__item justify-content-center mt-3 mb-3">
                            <div class="form__item__submit">
                                <Preloader v-if="isSending"/>
                                <input v-else type='submit' name="Submit" value="VOIR LE DEVIS"
                                       class="form_bt form_confirm_button form__item__submit__button btn btn-block"/>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationErrors :errorsList="errors"/>
            </form>
        </template>
    </div>
</template>

<script>
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import garantieFieldsLists from '../../mixins/garantieFieldsLists';
    import Preloader from '@/components/Preloader';
    import {DEBOUNCE} from "@/mixins/helper";
    import {TheMask} from 'vue-the-mask';
    import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';
    import {INSURANCE_AUTO, AUTO_ENGINE, AUTO_TYPE, AUTO_DURATION} from "@/constants/insuranceAuto";

    const INITIAL_FIELDS_VALUES = Object.freeze({
        id: '',
        civilite: 0,
        nom: '',
        prenom: '',
        name_of_signatory: '',
        adresse: '',
        cp: '',
        ville: '',
        tel: '',
        email: '',
        jour_permis: new Date().getDate(),          //
        mois_permis: new Date().getMonth() + 1,     // set today date
        annee_permis: new Date().getFullYear(),     //
        type_vehicule: 0,
        garantie: 0,
        duree: 0,
        marque_auto: '',
        modele_porteur: '',
        cylindree: 0,
        power_kw: 0,
        puis_fisc: '',
        immatriculation: '',
        jour_mise_en_circulation: '',
        mois_mise_en_circulation: '',
        annee_mise_en_circulation: '',
        num_serie: '',
        carburant: 0,
        km_reel: '',
        immatriculation_ancien_numero: '',
        jour_livraison: 1,
        mois_livraison: 1,
        annee_livraison: new Date().getFullYear(),
        jour_vente: 1,
        mois_vente: 1,
        annee_vente: new Date().getFullYear(),
        jour_prise_effet: '',
        mois_prise_effet: '',
        annee_prise_effet: '',
        assure: 0,
    });

    export default {
        name: 'GarantiesAuto',
        components: {ValidationErrors, Preloader, TheMask, CustomDatepicker},
        mixins: [garantieFieldsLists],
        data() {
            return {
                garantieAuto: {...INITIAL_FIELDS_VALUES},
                errors: {},
                isEdit: false,
                isVehicleSearching: false,
                isBusy: false,
                searchResult: null,
                searchVehicleResult: null,
                searchVehicleFilled: false,
                isClientSearching: false,
                isSending: false,
                effectiveDateInput: '',
                circulationDateInput: '',
                AUTO_ENGINE,
            }
        },
        computed: {
            existingCustomerFound() {
                return !!this.searchResult;
            },
            existingVehicleFound() {
                return !!this.searchVehicleResult;
            },
            insuranceTypeOptions() {
                return +this.garantieAuto.carburant === AUTO_ENGINE.ELECTRIC.ID
                    ? [
                        {name: INSURANCE_AUTO.TYPE_RESEAU.NAME, value: INSURANCE_AUTO.TYPE_RESEAU.ID},
                        {name: INSURANCE_AUTO.TYPE_MAXI_RESEAU.NAME, value: INSURANCE_AUTO.TYPE_MAXI_RESEAU.ID},
                    ]
                    : [
                        {name: INSURANCE_AUTO.TYPE_STANDARD.NAME, value: INSURANCE_AUTO.TYPE_STANDARD.ID},
                        {name: INSURANCE_AUTO.TYPE_RESEAU.NAME, value: INSURANCE_AUTO.TYPE_RESEAU.ID},
                        {name: INSURANCE_AUTO.TYPE_MAXI_RESEAU.NAME, value: INSURANCE_AUTO.TYPE_MAXI_RESEAU.ID},
                        {name: INSURANCE_AUTO.TYPE_MAXI_PLUS.NAME, value: INSURANCE_AUTO.TYPE_MAXI_PLUS.ID},
                        {name: INSURANCE_AUTO.TYPE_PRESTIGE.NAME, value: INSURANCE_AUTO.TYPE_PRESTIGE.ID},
                    ]
            },
            vehicleTypeOptions(){
                return [
                    {name: AUTO_TYPE.VP.NAME, value: AUTO_TYPE.VP.ID},
                    {name: AUTO_TYPE.VU.NAME, value: AUTO_TYPE.VU.ID},
                    {name: AUTO_TYPE['4X4'].NAME, value: AUTO_TYPE['4X4'].ID},
                ]
            },
            durationOprions() {
                let durationOptions = [
                    {name: AUTO_DURATION.MONTH_6.NAME, value: AUTO_DURATION.MONTH_6.ID},
                    {name: AUTO_DURATION.MONTH_12.NAME, value: AUTO_DURATION.MONTH_12.ID},
                    {name: AUTO_DURATION.MONTH_24.NAME, value: AUTO_DURATION.MONTH_24.ID},
                ];

                if (+this.garantieAuto.garantie === INSURANCE_AUTO.TYPE_STANDARD.ID ||
                    +this.garantieAuto.garantie === INSURANCE_AUTO.TYPE_RESEAU.ID) {
                    durationOptions.unshift({name: AUTO_DURATION.MONTH_3.NAME, value: AUTO_DURATION.MONTH_3.ID});
                }

                return durationOptions;
            }
        },
        methods: {
            searchByRegNumber: DEBOUNCE(function(val) {
                this.garantieAuto.immatriculation = this.garantieAuto.immatriculation.toUpperCase();

                let matched = this.garantieAuto.immatriculation.match(/(^([A-Z]{2}-[0-9]{3}-[A-Z]{2})+$)|(^([0-9]{3}-[A-Z]{3}-[0-9]{2})+$)/g);

                if (matched) {
                    let url = 'client/registration',
                        data = {
                            regNumber: this.garantieAuto.immatriculation
                        };
                    this.isVehicleSearching = true;
                    this.apiPost(url, data, false)
                        .then(response => {
                            if (response.data.info) {
                                this.searchVehicleResult = response.data.info;
                                this.parseVehicleInfo(this.searchVehicleResult);
                                this.searchVehicleFilled = true;
                            }

                            this.isVehicleSearching = false;
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                            this.isVehicleSearching = false;
                        })
                }
            }, 1000),
            searchClient: DEBOUNCE(function(val) {

                    if (this.garantieAuto.tel.length > 2) {
                        let url = 'client/searchOne',
                            data = {
                                tel: this.garantieAuto.tel
                            };
                        this.isClientSearching = true;
                        this.apiGet(url, data, false)
                            .then(response => {
                                if (response.data.client) {
                                    this.searchResult = response.data.client;
                                    this.parseClientInfo(this.searchResult);
                                    this.searchResult = null;
                                }

                                this.isClientSearching = false;
                            })
                            .catch(error => {
                                this.showErrorNotification(error);
                                this.isClientSearching = false;
                            })
                    }
                }, 1000),
            fillTheFields() {
                if (this.searchResult) {
                    this.parseClientInfo(this.searchResult);
                    this.searchResult = null;
                }
            },
            fillTheFieldsByImmatriculation() {
                if (this.searchVehicleResult) {
                    this.parseVehicleInfo(this.searchVehicleResult);
                    this.searchVehicleFilled = true;
                   // this.searchVehicleResult = null;
                }
            },
            serializeData() {
                return this.garantieAuto;
            },
            onSubmit(event) {
                this.garantieAuto.immatriculation = this.garantieAuto.immatriculation.toUpperCase();
                this.validateEffectiveDate();
                this.validateCirculationDate();
                this.isSending = true;
                let url = 'garantie/auto';
                if (this.isEdit && this.garantieAuto.id) {
                    url = 'garantie/auto/' + this.garantieAuto.id + '/edit';
                }

                this.apiPost(url, this.serializeData()).then((response) => {
                    this.isSending = false;
                    this.errors = {};

                    if (response.data.quote && response.data.status == 'success') {
                        if (response.data.calcQuotes)
                            this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                        this.showSuccessNotification(response.data.message, '');
                        this.$router.push('/garanties-auto-view/' + response.data.quote.id);

                    }
                }).catch(error => {
                    this.isSending = false;
                    this.errors = error.response.data;

                    if(error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
                        this.errors.errors = {};
                        this.errors.errors.error = [error.response.data.message];
                    }
                })
            },
            getQuoteInfo() {
                this.isBusy = true;
                let url = 'garantie/' + this.$route.params.id;
                this.apiGet(url)
                    .then(response => {
                        if (response.data.quote) {
                            this.parseQuoteInfo(response.data.quote);
                        }

                        this.isBusy = false;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                        this.$router.push('/');
                    })
            },
            parseVehicleInfo(info) {
                /* Car brand */
                if (info.Marque) {
                    this.garantieAuto.marque_auto = info.Marque.split('.').join('');
                }

                /* Modele */
                this.garantieAuto.modele_porteur = info.Modele ? info.Modele.toLocaleString() : null;
                /* Num serie */
                this.garantieAuto.num_serie = info.VIN ? info.VIN : null;

                /* CARBUTANT */
                if (info.Energie) {

                    //GAZ+ELEC => HYBRIDE
                    let carburantFromApi = info.Energie.toString();
                    if (carburantFromApi.toLowerCase().match(/gaz\+elec|\+elec/)) {
                      info.Energie = AUTO_ENGINE.HYBRIDE.NAME;
                      this.garantieAuto.carburant = AUTO_ENGINE.HYBRIDE.ID;
                    }
                    else {
                      if (info.Energie === 'GAZOLE') info.Energie = AUTO_ENGINE.DIESEL.NAME;
                      if (info.Energie === 'ELECTRIC') this.garantieAuto.carburant = AUTO_ENGINE.ELECTRIC.ID;
                    }

                    let founded = this.list_type_car_carburant.findIndex((item) => {
                        return item.toUpperCase() === info.Energie.toUpperCase();
                    });

                    if (founded > 0) {
                        this.garantieAuto.carburant = founded;
                    }
                }

                /* Cylindree */
                if (info.Cylindree) {
                    let cylindree = +info.Cylindree;

                    if (cylindree > 3500) {
                        this.garantieAuto.cylindree = 3;
                    } else if (cylindree >= 2500 && cylindree <= 3500) {
                        this.garantieAuto.cylindree = 2;
                    } else if (cylindree < 2500) {
                        this.garantieAuto.cylindree = 1;
                    }
                }

                /* Car type */
                let genre = info.Genre ? info.Genre.toUpperCase() : undefined,
                    genreCG = info.GenreCG ? info.GenreCG.toUpperCase() : undefined,
                    propulsion = info.Propulsion ? info.Propulsion.toUpperCase() : undefined;

                if (genre === 'CTTE' || genreCG === 'CTTE') {
                    this.garantieAuto.type_vehicule = AUTO_TYPE.VU.ID;
                } else if (propulsion === 'AVANT' || propulsion === 'ARRIERE') {
                    this.garantieAuto.type_vehicule = AUTO_TYPE.VP.ID;
                } else if (propulsion === '4X4') {
                    this.garantieAuto.type_vehicule = AUTO_TYPE['4X4'].ID;
                } else if (genre === 'VP' || genreCG === 'VP') {
                    this.garantieAuto.type_vehicule = AUTO_TYPE.VP.ID;
                } else if (genre === 'VU' || genreCG === 'VU') {
                    this.garantieAuto.type_vehicule = AUTO_TYPE.VU.ID;
                } else if (genre === '4X4' || genreCG === '4X4') {
                    this.garantieAuto.type_vehicule = AUTO_TYPE['4X4'].ID;
                }

                if (info.PuissFisc) {
                    this.garantieAuto.puis_fisc = +info.PuissFisc;
                }

                if (info.DateMec) {
                    this.circulationDateInput = new Date(info.DateMec);
                }
            },
            parseClientInfo(client) {
                this.garantieAuto.civilite = client.civility;
                this.garantieAuto.nom = client.last_name;
                this.garantieAuto.prenom = client.first_name;
                this.garantieAuto.name_of_signatory = client.name_of_signatory;
                this.garantieAuto.adresse = client.address;
                this.garantieAuto.cp = client.zip;
                this.garantieAuto.ville = client.city;
                this.garantieAuto.tel = client.tel;
                this.garantieAuto.email = client.email;
                this.garantieAuto.id_client = client.id;

            },
            parseQuoteInfo(quote) {
                this.garantieAuto.id = quote.id;

                if (quote.client && quote.client.id) {
                    this.parseClientInfo(quote.client);
                }

                if (quote.details.date_allowed) {
                    this.garantieAuto.jour_permis = +quote.details.datesParse.day_allowed;
                    this.garantieAuto.mois_permis = +quote.details.datesParse.month_allowed;
                    this.garantieAuto.annee_permis = +quote.details.datesParse.year_allowed;
                }


                this.garantieAuto.type_vehicule = quote.details.type_vehicle;
                this.garantieAuto.garantie = quote.details.garantie;
                this.garantieAuto.duree = quote.details.duration;
                this.garantieAuto.assure = quote.details.assistance;
                this.garantieAuto.marque_auto = quote.details.car_brand;
                this.garantieAuto.modele_porteur = quote.details.modele_porteur;
                this.garantieAuto.cylindree = quote.details.cylinder;
                this.garantieAuto.power_kw = quote.details.power_kw;
                this.garantieAuto.puis_fisc = quote.details.fiscal_power;
                this.garantieAuto.immatriculation = quote.details.registration;

                this.garantieAuto.jour_mise_en_circulation = quote.details.day_circulation;
                this.garantieAuto.mois_mise_en_circulation = quote.details.month_circulation;
                this.garantieAuto.annee_mise_en_circulation = quote.details.year_circulation;

                this.circulationDateInput = new Date(
                    quote.details.year_circulation,
                    quote.details.month_circulation - 1,
                    quote.details.day_circulation,
                );

                this.garantieAuto.num_serie = quote.details.serial_number;
                this.garantieAuto.carburant = quote.details.car_fuel;
                this.garantieAuto.km_reel = quote.details.km_real;
                this.garantieAuto.immatriculation_ancien_numero = quote.details.registration_old_number;


                if (quote.details.delivery_date) {
                    this.garantieAuto.jour_livraison = +quote.details.datesParse.day_delivery;
                    this.garantieAuto.mois_livraison = +quote.details.datesParse.month_delivery;
                    this.garantieAuto.annee_livraison = +quote.details.datesParse.year_delivery;
                }

                if (quote.details.sale_date) {
                    this.garantieAuto.jour_vente = +quote.details.datesParse.day_sale;
                    this.garantieAuto.mois_vente = +quote.details.datesParse.month_sale;
                    this.garantieAuto.annee_vente = +quote.details.datesParse.year_sale;
                }

                if (quote.details.effective_date) {
                    let effective_day = quote.details.datesParse.day_effective,
                        effective_month = quote.details.datesParse.month_effective - 1,
                        effective_year = quote.details.datesParse.year_effective;

                    this.garantieAuto.jour_prise_effet = +effective_day;
                    this.garantieAuto.mois_prise_effet = +effective_month;
                    this.garantieAuto.annee_prise_effet = +effective_year;

                    this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
                }
            },
            validateEffectiveDate() {
                if(!this.effectiveDateInput) return false;
                let date = this.moment(this.effectiveDateInput);

                this.garantieAuto.jour_prise_effet = date.format('D');
                this.garantieAuto.mois_prise_effet = date.format('M');
                this.garantieAuto.annee_prise_effet = date.format('YYYY');

                return true;
            },
            resetEffectiveDate() {
                this.garantieAuto.jour_prise_effet = 1;
                this.garantieAuto.mois_prise_effet = 1;
                this.garantieAuto.annee_prise_effet = 1970;
            },
            cleanEffectiveDate() {
                this.garantieAuto.jour_prise_effet = '';
                this.garantieAuto.mois_prise_effet = '';
                this.garantieAuto.annee_prise_effet = '';
            },
            validateCirculationDate() {
                if(!this.circulationDateInput) return false;
                let date = this.moment(this.circulationDateInput);

                this.garantieAuto.jour_mise_en_circulation = date.format('D');
                this.garantieAuto.mois_mise_en_circulation = date.format('M');
                this.garantieAuto.annee_mise_en_circulation = date.format('YYYY');

                return true;
            },
            resetCirculationDate() {
                this.garantieAuto.jour_mise_en_circulation = '';
                this.garantieAuto.mois_mise_en_circulation = '';
                this.garantieAuto.annee_mise_en_circulation = '';
            },
            hasError(field) {
                return !!(this.errors.errors && this.errors.errors[field]);
            },
        },
        beforeRouteLeave(to, from, next) {
            this.garantieAuto = INITIAL_FIELDS_VALUES;
            next();
        },
        mounted() {
            if (this.$route.params.id) {
                this.getQuoteInfo();
                this.isEdit = true;
                this.searchVehicleFilled = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantiesAuto.vue